import { GetSpaceBase } from '../../types/GetSpaceBase';
import { getUndefinedSpace } from '../../utils/getUndefinedSpace';
import { spaceFactory } from '../../utils/spaceFactory';

export const getSpaceDavivienda: GetSpaceBase = (group, space, context) => {
  const { negBooleans } = context;
  const {
    isNormalization,
    isApprovedByBank,
    isRejected,
  } = negBooleans!;

  switch (group) {
    case 'NEG_OPTION': {
      switch (space) {
        case 'state.alert': {
          if (isNormalization) {
            if (isRejected) return spaceFactory('NEG_OPTION.state.alert.normalization.rejected').get();
            if (isApprovedByBank) return spaceFactory('NEG_OPTION.state.alert.normalization.approvedByBank').get();
            return spaceFactory('NEG_OPTION.state.alert.normalization').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    default: break;
  }

  return getUndefinedSpace();
};
